import { g as n } from "./index767.mjs";
import "./index747.mjs";
import { c as y } from "./index768.mjs";
import { d } from "./index740.mjs";
import { d as v } from "./index764.mjs";
import { c as u } from "./index769.mjs";
import { i as P } from "./index770.mjs";
import { __exports as b } from "./index753.mjs";
var f = n, g = b.f, G = y, T = d, _ = v, h = u, C = P, I = function(r, s) {
  var a = r.target, l = r.global, m = r.stat, c, e, t, o, i, p;
  if (l ? e = f : m ? e = f[a] || _(a, {}) : e = f[a] && f[a].prototype, e)
    for (t in s) {
      if (i = s[t], r.dontCallGetSet ? (p = g(e, t), o = p && p.value) : o = e[t], c = C(l ? t : a + (m ? "." : "#") + t, r.forced), !c && o !== void 0) {
        if (typeof i == typeof o)
          continue;
        h(i, o);
      }
      (r.sham || o && o.sham) && G(i, "sham", !0), T(e, t, i, r);
    }
};
export {
  I as _
};
